import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "@remix-run/react";

import type * as typo3 from "~/modules/typo3/schema";
import useSpecialPageUrl from "~/hooks/useSpecialPageUrl";
import Return from "~/components/icons/Return";
import { renderProjectType } from "~/components/shared/ProjectType";

type ProjectEssentialsTitleProps = {
	article: typo3.Project;
};

export default function ProjectEssentialsTitle({
	article,
}: ProjectEssentialsTitleProps) {
	const projectsPageUrl = useSpecialPageUrl("projectsPage");
	const parentArticle = article.articleParent;
	const isStudyProject = article.projectType !== "0";
	const label = renderProjectType(article);

	const returnButton = useMemo(() => {
		const backUrl = isStudyProject
			? (parentArticle?.detailsUrl ?? projectsPageUrl)
			: undefined;

		if (backUrl) {
			return (
				<Link className="button--blank icon-button" to={backUrl}>
					<Return />
					<span>
						<FormattedMessage
							id={
								parentArticle?.detailsUrl
									? "projectEssentialsTitle.backToGroupProject"
									: "projectEssentialsTitle.backToProjects"
							}
						/>
					</span>
				</Link>
			);
		}
	}, [isStudyProject, parentArticle?.detailsUrl, projectsPageUrl]);

	return (
		<header className="page-title essential-item essentials-header sticky top-0">
			{returnButton && (
				<div className="button-return-container">{returnButton}</div>
			)}

			<div className="inner">
				<div className="label head top">{label}</div>
				<h1 className="title">{article.title}</h1>
				<div className="meta bottom label">{article.subtitle}</div>
			</div>
		</header>
	);
}
